
export default {
  name: 'CalculatorHeader'
};
